class CytoService {

  public unselectAllNodes(instance: cytoscape.Core) {
    instance.nodes()
      .filter((n: any) => '|root|node|leaf|'.includes(n.data('type')))
      .css('border-width', 1)
    instance.nodes().toggleClass('delete, deleteNode', false)
    instance.nodes().unselect()
  }

  public zoomIn(instance: cytoscape.Core) {
    let level = instance.zoom()
    level += 0.2
    instance.zoom(level)
  }

  public zoomOut(instance: cytoscape.Core) {
    let level = instance.zoom()
    level -= 0.2
    instance.zoom(level)
  }

  public removeDeadEdges(cy: any) {
    if (cy) {
      cy.nodes()
        .filter(this.isEmptyGroup)
        .forEach((g: any) => this.removeEdges(cy, g))
    }
  }

  private isEmptyGroup(node: any) {
    return node.data('type') === "group" && node.children().length === 0;
  }

  private removeEdges(cy: any, node: any) {
    cy.edges(`[source='${node.data("id")}']`).remove()
    cy.edges(`[target='${node.data("id")}']`).remove()
  }
}

export default new CytoService()
